<ion-header>
  <ind-page-title [viewData]="pageTitleViewData" (onControlClick)='onPageTitleControlClick($event)'></ind-page-title>
  <div class="searchbar-wrapper">
    <ion-searchbar placeholder="{{searchPlaceholder}}" disabled="true"></ion-searchbar>
  </div>
  <!--Customer Glance Card-->
  <glance-card *ngIf="contactGlanceViewData" [viewData]="contactGlanceViewData"
    (onControlClick)="onQuickGlanceControlClick($event)"> </glance-card>
</ion-header>
<ion-content>
  <ind-section-header [viewData]='meetingHistorySectionHeader' ></ind-section-header>
  <ion-list class="event-items-list" *ngIf="viewMeetingHistoryItems.length > 0">
    <timeline-item *ngFor="let item of viewMeetingHistoryItems; trackBy: trackById" [inputData]="item"
      (clickedOnHeader)="openItemDetails($event)"></timeline-item>
    <ion-infinite-scroll (ionInfinite)="doInfinite($event)" threshold="30%">
      <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-list>
  <ion-list>
    <div class="no-data-message" *ngIf="viewMeetingHistoryItems.length == 0">
      {{ 'NO_ACTIVITIES' | translate}}
    </div>
  </ion-list>
</ion-content>
<footer-toolbar *ngIf="footerService.shouldShowFooter$ | async" [footerView]="'detailView'" [selectedView]="'contacts'"></footer-toolbar>